import { HOTJAR_USER_ID } from "@/constants";
import type ICompanyInformation from "@/types/CompanyInformation";
import type IUserInformation from "@/types/UserInformation";

interface HotJarIdentityData {
    companyData: ICompanyInformation;
    userData: IUserInformation;
}

/**
 * Appends the hotjar identity script to the head of the document.
 * Uses JSON.stringify() to safely serialize user data and prevent
 * JavaScript syntax errors from special characters (quotes, backslashes, etc.)
 */
export const createHotJarIdentityScript = ({
    companyData,
    userData,
}: HotJarIdentityData) => {
    const identityData = {
        "Company name": companyData.name ?? "",
        "Company type": companyData.company_type ?? "",
        "Company country": companyData.country ?? "",
        "User first name": userData.first_name ?? "",
        "User last name": userData.last_name ?? "",
        "User email address": userData.email ?? "",
    };

    const script = document.createElement("script");

    script.id = "hotjar-identities";
    script.type = "text/javascript";
    script.text = `
        window.hj(
            'identify', 
            ${HOTJAR_USER_ID},
            ${JSON.stringify(identityData)});
    `;

    document.head.appendChild(script);
};
